import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEsc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEsc"><Path fillRule="evenodd" clipRule="evenodd" d="M12.75 1V6.5H11.25V1H12.75ZM7.8654 4.57147C5.25959 6.0252 3.5 8.80764 3.5 12C3.5 16.6945 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6945 20.5 12C20.5 8.82953 18.7645 6.06341 16.1881 4.60155L16.9283 3.29693C19.9552 5.01436 22 8.26792 22 12C22 17.5229 17.5228 22 12 22C6.47715 22 2 17.5229 2 12C2 8.24212 4.07317 4.96944 7.1346 3.26153L7.8654 4.57147Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEsc;
